<section class="riesgo-dialog seguimiento-riesgo-dialog">
  <header class="riesgo-dialog__header">
    <div>
      <div class="riesgo-dialog__eyebrow">Riesgo {{ riesgo?.id }}</div>
      <h2>Seguimientos de riesgo</h2>
      <p>Consulte el historial y registre la evolución del riesgo.</p>
    </div>
    <button type="button" mat-icon-button class="riesgo-dialog__close" (click)="onNoClick()"
      aria-label="Cerrar seguimientos de riesgo" matTooltip="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div mat-dialog-content class="riesgo-dialog__content">
    <section class="seguimiento-datos">
      <div class="row align-items-start">
        <div class="col-12 col-lg-9">
          <div class="seguimiento-datos__info-card">
            <div class="d-flex flex-wrap align-items-center seguimiento-datos__title-row">
              <h3 class="seguimiento-datos__title">Riesgo {{ riesgo?.id }}</h3>
              <span class="badge seguimiento-datos__badge" [ngClass]="riesgo?.estatus ? 'badge-success' : 'badge-warning'">
                {{ riesgo?.estatus ? 'MITIGADO' : 'ACTIVO' }}
              </span>
            </div>
            <div class="row mt-3">
              <div class="col-12 col-md-4 mb-3 mb-md-0">
                <div class="seguimiento-datos__label">Fase de detección</div>
                <div class="seguimiento-datos__value">{{ riesgo?.faseDeteccion?.nombre_faseDeteccion || 'Sin fase' }}</div>
              </div>
              <div class="col-12 col-md-8">
                <div class="seguimiento-datos__label">Descripción del riesgo</div>
                <div class="seguimiento-datos__value">{{ riesgo?.descripcion || 'Sin descripción' }}</div>
              </div>
            </div>
            <div class="mt-3 pt-3 border-top">
              <div class="seguimiento-datos__label">Causa raíz</div>
              <div class="seguimiento-datos__cause">{{ riesgo?.causa_raiz || 'Sin causa raíz registrada' }}</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-3 mt-3 mt-lg-0">
          <div class="seguimiento-datos__summary-card mb-2">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div>
                <div class="seguimiento-datos__label mb-1">Severidad actual</div>
                <div class="seguimiento-datos__severity-value">{{ riesgo?.severidad?.descripcion || 'Sin severidad' }}</div>
              </div>
              <mat-icon class="seguimiento-datos__severity-icon" [ngClass]="riesgo?.estatus ? 'text-success' : 'text-danger'">
                {{ riesgo?.estatus ? 'check_circle' : 'warning' }}
              </mat-icon>
            </div>
            <div class="progress seguimiento-datos__progress">
              <div class="progress-bar" role="progressbar" [style.width.%]="riesgo?.calculo_severidad || 0"
                [ngClass]="riesgo?.estatus ? 'bg-success' : 'bg-danger'" [attr.aria-valuenow]="riesgo?.calculo_severidad || 0"
                aria-valuemin="0" aria-valuemax="100"></div>
            </div>
          </div>
          <div class="seguimiento-datos__summary-card">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <div class="seguimiento-datos__label mb-1">Periodicidad</div>
                <div class="seguimiento-datos__severity-value seguimiento-datos__severity-value--sm">
                  {{ riesgo?.periodicidad?.descripcion || 'Sin periodicidad' }}
                </div>
              </div>
              <mat-icon class="seguimiento-datos__severity-icon text-info">schedule</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="riesgo-dialog__section">
      <div class="riesgo-dialog__section-head">
        <div>
          <h3>Historial de seguimientos</h3>
          <p>Registros asociados al riesgo seleccionado.</p>
        </div>
        <button type="button" mat-raised-button class="app-form-btn app-form-btn--primary" (click)="agregarSeguimiento()"
          *ngIf="!agregarSeguimientoBtn">
          <mat-icon>add</mat-icon>
          Agregar seguimiento
        </button>
      </div>

      <div class="table-responsive riesgo-dialog__table-wrap">
        <table id="datatables" class="table table-shopping table-striped table-no-bordered table-hover" datatable
          [dtOptions]="dt" cellspacing="0" width="100%">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Probabilidad</th>
              <th>Impacto</th>
              <th>Severidad</th>
              <th>Resultado</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let seguimiento of listaSeguimiento">
              <td>{{ seguimiento.fecha }}</td>
              <td>{{ seguimiento.valorProbabilidad }}{{ ' (' + seguimiento.descripcionProbabilidad + ')' }}</td>
              <td>{{ seguimiento.id_valor_impacto }}{{ ' (' + seguimiento.descripcionImpacto + ')' }}</td>
              <td>{{ seguimiento.valorSeveridad }}{{ ' (' + seguimiento.descripcionProXRiesgo + ')' }}</td>
              <td>{{ seguimiento.resultado }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section class="seguimiento-riesgo-dialog__form" *ngIf="agregarSeguimientoBtn">
      <div class="riesgo-dialog__section-head">
        <div>
          <h3>Agregar seguimiento</h3>
          <p>Capture los valores y el resultado de la nueva evaluación.</p>
        </div>
      </div>
      <div class="seguimiento-riesgo-dialog__form-grid">
        <mat-form-field appearance="outline">
          <mat-label>Probabilidad</mat-label>
          <mat-select required [(ngModel)]="objetoSeguimiento.id_valor_probabilidad">
            <mat-option *ngFor="let prob of probabilidad" [value]="prob.id_probabilidad">
              {{ prob.nombre }} ({{ prob.valor }})
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Impacto</mat-label>
          <mat-select required [(ngModel)]="objetoSeguimiento.id_valor_impacto">
            <mat-option *ngFor="let imp of impacto" [value]="imp.id_impacto">
              {{ imp.descripcion }} ({{ imp.valor }})
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Severidad</mat-label>
          <mat-select required [(ngModel)]="objetoSeguimiento.id_severidad">
            <mat-option *ngFor="let severidadItem of severidad" [value]="severidadItem.id_severidad">
              {{ severidadItem.descripcion }} ({{ severidadItem.probabilidad_ximpacto }})
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>¿Cerrar el riesgo?</mat-label>
          <mat-select required [(ngModel)]="estatusRiesgo">
            <mat-option [value]="false">No</mat-option>
            <mat-option [value]="true">Sí</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="seguimiento-riesgo-dialog__result">
          <mat-label>Resultado</mat-label>
          <textarea maxlength="500" matInput rows="4" [(ngModel)]="objetoSeguimiento.resultado"
            aria-label="Resultado"></textarea>
        </mat-form-field>
      </div>
      <footer class="riesgo-dialog__footer">
        <button type="button" mat-stroked-button class="app-form-btn app-form-btn--secondary" (click)="cancelarSeguimiento()">
          Cancelar
        </button>
        <button type="button" mat-raised-button class="app-form-btn app-form-btn--primary" (click)="save()">
          <mat-icon>save</mat-icon>
          Guardar seguimiento
        </button>
      </footer>
    </section>
  </div>
</section>
